/**
 * Tracks product PDP views and /products/ link clicks for cart suggestion logic.
 */
import { trackProductView } from '@theme/azuli-session-products';

function initFromProductPage() {
  const handle = document.body.dataset.productHandle;
  if (handle) trackProductView(handle);
}

document.addEventListener(
  'click',
  (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const link = target.closest('a[href*="/products/"]');
    if (!(link instanceof HTMLAnchorElement)) return;
    const match = link.pathname.match(/\/products\/([^/?#]+)/);
    if (match?.[1]) trackProductView(match[1]);
  },
  true
);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFromProductPage);
} else {
  initFromProductPage();
}
